import { InputAdornment } from '@mui/material';
import CardFrom, { CardFormConfig } from '../../component/card/card-from';
import { useEffect, useState } from 'react';
import DialogComponent from '../../component/dialog/dialog.component';
import { Box, Button } from '@mui/material';
import i18n from '../../i18n';
import ButtonComponent from '../../component/button/button.component';
import apiManage from '../../request';
import GlobalNotification from '../../component/common/snackbar';
import { Restaurant } from '../../models';
import _ from 'lodash';

export default function ISVFeeSetting(props: Readonly<{
    // mode
    actionMode: 'ADD' | 'EDIT';
    // 编辑详情
    detail: Restaurant[];
    // 弹窗开关
    isOpen: boolean;
    // 关闭弹窗
    handleClose: () => void;
    // 确定
    handleConfirm: () => void;
}>) {

    useEffect(() => {
        if (props.isOpen) {
            const detail = props.detail.map((item) => ({
                isv_fee: Number(item.isv_fee ?? 0).toFixed(2),
                nickname: item.nickname,
                string_id:item.string_id
            }))
            setDetail(detail)
        }
    }, [props.isOpen])

    // 详情数据
    const [detail, setDetail] = useState<ISVDataProps[]>([])

    /**
     * 确定加入iSV
     */
    const handleAddConfirm = async () => {
        let result;
        if (props.actionMode === 'ADD') {
            // 新增
            result = await apiManage.patch_restaurant_manual_join_isv({
                joinIsvInfo: detail.map((item) => (
                    {
                        string_id: item.string_id ?? '',
                        isv_fee: Number(item.isv_fee ?? 0)
                    }
                ))
            })
        } else {
            // 编辑
            result = await apiManage.patch_restaurant_info({
                isv_fee: Number(detail[0]?.isv_fee ?? 0)
            }, props.detail[0]?._id ?? '')

        }
        if (result && !result.error) {
            GlobalNotification.success(i18n.t('global_text_operate_success'));
            props.handleConfirm()
        } else {
            GlobalNotification.error(i18n.t('global_text_operate_failure'));
        }
    }


    /**
     * 表单回调
     * @param value
     */
    const onFormChange = (value: string, key: string) => {
        const newValue = value.slice(0, value.indexOf('.') + 3);
        const data = detail;
        _.set(data, key, newValue)
        setDetail([...detail])

    }

    // 表单
    const cardConfig: CardFormConfig[] = [{
        columnSpacing: { xs: 2 },
        rowSpacing: 2,
        key: 'base_setting_title',
        title: '',
        md: 12,
        children: detail.map((item, index) => (
            {
                key: `${index}.isv_fee`,
                subTitle: detail.length > 1 ? `${index + 1}. ${item.nickname ?? ''}` : `${item.nickname ?? ''}`,
                label: 'viva_wallet_setting_page_text_isv_fee',
                comType: 'INPUT',
                xs: 12,
                contentType: 'number',
                inputProps: {
                    min: 0,
                    max: 100,
                },
                InputProps: {
                    endAdornment: (< InputAdornment position='end'>%</InputAdornment>),
                },
                inputIsEdited: false,
                onChange: (e) => onFormChange(e.target.value, `${index}.isv_fee`)
            }
        ))
    }]

    return (
        <DialogComponent
            open={props.isOpen}
            maxWidth='xs'
            heightSize='small'
            defaultHeaderProps={{
                title: 'ISV',
            }}
            onClose={props.handleClose}
            footer={(
                <>
                    <Button
                        color='primary'
                        variant='outlined'
                        onClick={props.handleClose}
                    >{i18n.t('google_text_public_button_cancel')}</Button>
                    <Box marginLeft={4} display='inline-block'>
                        <ButtonComponent
                            color='primary'
                            variant='contained'
                            async
                            handleClick={handleAddConfirm}
                        >
                            {i18n.t('google_text_confirm')}
                        </ButtonComponent>
                    </Box>

                </>

            )} >
            <CardFrom
                config={cardConfig}
                data={detail}
            />
        </DialogComponent>
    )
}

// 餐馆props
export type ISVDataProps = {
    isv_fee?: string;
    nickname?: string;
    string_id?: string;
}